import { useGetCashMutationReports } from 'api-hooks/report';
import { NavigationRoutes } from 'common/constants';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { NavigationProps } from 'types';

import PivotReportTemplate from './components/pivot-report-template';

export type CashMutationReportParams = {
  filter: {
    cash_account: string;
  };
};

export default function CashMutationReport(
  props: NavigationProps<NavigationRoutes.CashMutationReport>,
) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:cash_mutation_report')}
      usePivotQuery={useGetCashMutationReports}
      defaultFilters={[
        {
          name: 'cash_account',
          value: query['filter[cash_account]'] as string,
        },
        ...defaultFilters,
      ]}
      isShowAllFilterCompleted
    />
  );
}
